import { render } from "./NotificationAlert.vue?vue&type=template&id=12284ea4&ts=true"
import script from "./NotificationAlert.vue?vue&type=script&lang=ts"
export * from "./NotificationAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__